import { render, staticRenderFns } from "./ListLayout.vue?vue&type=template&id=ad2c1006&"
import script from "./ListLayout.vue?vue&type=script&lang=ts&"
export * from "./ListLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports